import { Box, Center, Flex, Heading, Image } from "@chakra-ui/react";
import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import { Loader } from "../../components/Loader";
import { useVerifyAccountUsingVerificationCodeMutation } from "../../graphql";
import { Header } from "../../layouts/Dashboard/styles";

const VerifyAccountPage: React.FC = ({ children }) => {
    const { code } = useParams<{ code: string }>();
    const [verify, { loading, data }] =
    useVerifyAccountUsingVerificationCodeMutation();

    const handleVerify = async () => {
        await verify({ variables: { code: code } });
    };

    useEffect(() => {
        handleVerify();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <>
            <Flex width="full" align="center" justifyContent="center" marginTop={ 20 }>
                <Box
                    p={ 5 }
                    background="white"
                    borderWidth={ 1 }
                    borderRadius={ 8 }
                    boxShadow="lg"
                    w={ [400, 500] }
                >
                    <Header>
                        <Image src="/logo-white.png" />
                    </Header>
                    <Center marginTop={ "50px" }>
                        { loading && <Loader /> }
                        <Heading size="lg" textAlign={ "center" }>
                            { data?.verifyAccountUsingVerificationCode?.message }
                        </Heading>
                    </Center>
                </Box>
            </Flex>
        </>
    );
};

export default VerifyAccountPage;
